import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { actionOnMessage } from '@skynet/data-ws-mm';
import { parseResponse } from '@skynet/data-ws-core';

import { TaskCommands } from 'src/store/shared/tasks/actions';
import { listen as listenLoans } from 'src/store/loans/actions';
import { listen as listenRetainers } from 'src/store/retainers/actions';
import type { JsonTasksSuccess, TasksState } from './types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';

const allowedCommands = Object.values(TaskCommands);

export const INITIAL_TASKS_FILTER_STATE = {
  selectedStatus: [],
  sortKey: 'date:desc',
  searchValue: '',
  selectedTypes: [],
};

export const initialState: TasksState = {
  error: null,
  list: {},
  requestStatus: null,

  ...INITIAL_TASKS_FILTER_STATE,
};

const Tasks = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    resetFilters(state) {
      state.selectedStatus = [];
      state.selectedTypes = [];
      state.sortKey = 'date:desc';
    },
    resetSearchValue(state) {
      state.searchValue = '';
    },
    setSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    setSortKey(state, action: PayloadAction<string>) {
      state.sortKey = action.payload;
    },
    setSelectedStatus(state, action: PayloadAction<string[]>) {
      state.selectedStatus = action.payload;
    },
    setSelectedTypes(state, action: PayloadAction<string[]>) {
      state.selectedTypes = action.payload;
    },

    // resetTasks(state) {
    //
    //   state.mm = [];
    //   state.icebergs = [];
    //   state.adaptives = [];
    //   state.liquid = [];
    //   state.dla = [];
    //   state.tiered = [];
    //   state.menkar = [];
    // },
  },
  extraReducers: (builder) => {
    // on WS message

    builder.addCase(listenLoans, (state, action) => {
      const { section } = action.payload;
      const { isInitCall } = action.meta;
      if (isInitCall && section === 'tasks') {
        state.requestStatus = 'pending';
      }
    });

    builder.addCase(listenRetainers, (state, action) => {
      const { section } = action.payload;
      const { isInitCall } = action.meta;
      if (isInitCall && section === 'tasks') {
        state.requestStatus = 'pending';
      }
    });

    builder.addCase(actionOnMessage, (state, action) => {
      const { json, skipProcessing, error } = parseResponse(action.payload, allowedCommands);

      if (skipProcessing || !json) return;

      console.debug(
        `shared/tasks/processing ${actionOnMessage.toString()}`,
        action,
        allowedCommands,
      );

      if (error) {
        state.error = error;
        return;
      }

      state.error = null;

      const { command } = json;

      // @deprecated delete "command === TaskCommands.Bots " after update backend into
      if (command === TaskCommands.Tasks) {
        const {
          list,
          types,
          adaptives,
          icebergs,
          liquid,
          dla,
          mm,
          tiered,
          menkar,
          id,
        }: JsonTasksSuccess = json;

        state.list[id] = {
          // new model
          list,
          types,
          // @deprecated transitional grouped arrays
          adaptives,
          icebergs,
          liquid,
          dla,
          mm,
          tiered,
          menkar,
        };
        state.requestStatus = 'success';
      }
    });
  },
});

export const tasksActions = {
  ...Tasks.actions,
};

const persistConfig = {
  key: 'tasks',
  version: 1,
  storage,
  whitelist: ['sortKey', 'selectedTypes', 'selectedStatus'],
};

const persistedTasksKeys = persistReducer(persistConfig, Tasks.reducer);

// export const { toggleSidebar, openNewLoanModal, closeNewLoanModal } = Balances.actions

export default persistedTasksKeys;
